var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack510({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,7a1.55,1.55,0,0,1,1.3.6A3.79,3.79,0,0,1,9.83,10a3.81,3.81,0,0,1-.56,2.33,1.54,1.54,0,0,1-1.3.59,1.63,1.63,0,0,1-1.35-.64A3.81,3.81,0,0,1,6.11,10a3.81,3.81,0,0,1,.56-2.33A1.58,1.58,0,0,1,8,7Zm0,.91a.56.56,0,0,0-.35.13.83.83,0,0,0-.25.45A6.8,6.8,0,0,0,7.26,10a6.07,6.07,0,0,0,.1,1.38,1,1,0,0,0,.26.51.57.57,0,0,0,.71,0,.86.86,0,0,0,.24-.45A6.62,6.62,0,0,0,8.68,10a6.24,6.24,0,0,0-.1-1.39.92.92,0,0,0-.26-.5A.56.56,0,0,0,8,7.94Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack510);
export default __webpack_public_path__ + "static/media/Symbolpack_5_10.be95539a2a6e6b927af806ef8814e144.svg";
export { ForwardRef as ReactComponent };